var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "large-12" },
    [
      _c("div", { staticClass: "row wrapper-spacing" }, [
        _c("div", { staticClass: "medium-12 large-12 columns" }, [
          _c("h3", [_vm._v("Stichtag")]),
          _vm._v(" "),
          !_vm.showStyle
            ? _c(
                "div",
                { staticClass: "spv-select-group flex-no-wrap row" },
                _vm._l(_vm.deadlines, function(d) {
                  return _c(
                    "div",
                    { key: d.id, class: "small-6 medium-4 large-4 columns" },
                    [
                      _c("div", { staticClass: "radio-input" }, [
                        _c("input", {
                          attrs: {
                            id: _vm.indexId + "-" + d.id,
                            name: _vm.indexId + "-deadline",
                            type: "radio"
                          },
                          domProps: {
                            checked: _vm.deadline_id == d.id,
                            value: d.id
                          },
                          on: {
                            change: function($event) {
                              _vm.onSelectDeadline(d.id)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            class: { checked: _vm.deadline_id == d.id },
                            attrs: { for: _vm.indexId + "-" + d.id }
                          },
                          [_c("p", [_vm._v(_vm._s(d.name))])]
                        )
                      ])
                    ]
                  )
                })
              )
            : _c("div", { staticClass: "spv-select-group" }, [
                _c("div", { staticClass: "small-12 medium-6 large-4" }, [
                  _c(
                    "select",
                    {
                      staticClass: "spv-input-select",
                      domProps: { value: _vm.deadline_id },
                      on: {
                        change: function(e) {
                          return _vm.onSelectDeadline(e.target.value)
                        }
                      }
                    },
                    _vm._l(_vm.deadlines, function(d) {
                      return _c(
                        "option",
                        { key: d.id, domProps: { value: d.id } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(d.name) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  )
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row wrapper-spacing" }, [
        _c("div", { staticClass: "medium-12 large-6 columns" }, [
          _c("h3", [_vm._v("Zeitraum")]),
          _vm._v(" "),
          _c("div", { staticClass: "large-8" }, [
            _c(
              "select",
              {
                staticClass: "spv-input-select",
                domProps: { value: _vm.year_ },
                on: {
                  change: function(e) {
                    return _vm.onSelectYear(e.target.value)
                  }
                }
              },
              _vm._l(_vm.years, function(y) {
                return _c("option", { key: y, domProps: { value: y } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.deadline_id === "j"
                          ? "Jun " + y + " - Mai " + (y + 1)
                          : "Dez " + y + " - Nov " + (y + 1)
                      ) +
                      "\n          "
                  )
                ])
              })
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row wrapper-spacing" }, [
        _c("div", { staticClass: "medium-12 large-12 columns" }, [
          _c("h1", [
            _vm._v("Normierte Wertentwicklung "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.indexName_) } }),
            _vm._v(" " + _vm._s(_vm.deadline_.name))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "large-12 columns spv-chart-wrapper" },
            [
              _c("index-chart", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.deadline_id === "j",
                    expression: "deadline_id === 'j'"
                  }
                ],
                attrs: {
                  data: _vm.chart_items["j"] || [],
                  max: _vm.chart_max["j"] || 0,
                  name: _vm.indexName_,
                  color: "#E81700"
                }
              }),
              _vm._v(" "),
              _c("index-chart", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.deadline_id === "d",
                    expression: "deadline_id === 'd'"
                  }
                ],
                attrs: {
                  data: _vm.chart_items["d"] || [],
                  max: _vm.chart_max["d"] || 0,
                  name: _vm.indexName_,
                  color: "#E81700"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "spv-price-inquiry" }, [
                _c("b", { staticClass: "spv-price-inquiry__label" }, [
                  _vm._v("Kursabfrage")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "spv-price-inquiry__date-picker" },
                  [
                    _c("span", [_vm._v("Datum")]),
                    _vm._v(" "),
                    _c("date-picker", {
                      attrs: {
                        min: _vm.minDate,
                        max: _vm.maxDate,
                        value: _vm.inquiry_date
                      },
                      on: { select: _vm.onSelectInquiryDate }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "spv-price-inquiry__value" }, [
                  !_vm.inquiry_valid && !_vm.inquiry_date
                    ? _c("span", { staticClass: "error-value" }, [
                        _vm._v(
                          "\n              Bitte wählen Sie ein Datum\n            "
                        )
                      ])
                    : _vm.inquiry_value === -1
                      ? _c("span", { staticClass: "error-value" }, [
                          _vm._v(
                            "\n              Für dieses Datum liegt kein Datensatz vor. Bitte wählen Sie ein anderes Datum aus\n            "
                          )
                        ])
                      : !!_vm.inquiry_value
                        ? _c("span", [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.indexName_) }
                            }),
                            _vm._v("  "),
                            _c("b", [
                              _vm._v(_vm._s(_vm.inquiry_value) + " Punkte")
                            ])
                          ])
                        : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "button button-small block",
                    on: { click: _vm.loadDayValue }
                  },
                  [_vm._v("Anzeigen")]
                )
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.configText
        ? _c("div", { staticClass: "row wrapper-spacing" }, [
            _c("div", { staticClass: "medium-12 large-12 columns" }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.configText) } })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show_data
        ? [
            _vm.show_percent
              ? _c("index-euro-table", {
                  attrs: {
                    "index-id": _vm.indexId,
                    "index-name": _vm.indexName_,
                    items: _vm.details_data.index_values || [],
                    "info-texts": _vm.gloss_texts_vip_euro,
                    month: _vm.deadline_.name,
                    "target-vol": _vm.targetVol,
                    "yearly-yield": _vm.details_data.yearly_yield,
                    "decisive-yield": _vm.details_data.decisive_yearly_yield
                  },
                  on: { print: _vm.onPrint }
                })
              : _c("index-trend-table", {
                  attrs: {
                    "index-id": _vm.indexId,
                    "index-name": _vm.indexName_,
                    items: _vm.details_data.index_values || [],
                    month: _vm.deadline_.name,
                    year: _vm.details_data.year,
                    "target-vol": _vm.targetVol,
                    "yearly-yield": _vm.details_data.yearly_yield,
                    "decisive-yield": _vm.details_data.decisive_yearly_yield,
                    "factsheet-path": _vm.factsheet_path[_vm.deadline_id]
                  },
                  on: {
                    print: _vm.onPrint,
                    "download-pdf": _vm.onDownloadFactsheet,
                    "open-pdf": _vm.onOpenFactsheet
                  }
                })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.lastConstituent && _vm.indexId === "trend"
        ? _c("div", { staticClass: "row wrapper-spacing" }, [
            _c("div", { staticClass: "medium-12 large-12 columns" }, [
              _c("h1", [
                _vm._v(
                  "Zusammensetzung der Anlageklassen TrendPortfolio Index " +
                    _vm._s(_vm.deadline_.name)
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("b", [
                  _vm._v(
                    "Stand " +
                      _vm._s(
                        _vm.lastConstituent.month_name +
                          " " +
                          _vm.lastConstituent.year
                      )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Die für den angegebenen Monat ausgewählten Anlageklassen sind in rot dargestellt."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Die ausgewählten Anlageklassen gehen gleichgewichtet (zu je 25 %) in den Index ein. Falls weniger als vier Anlageklassen positive Trends aufzeigen und damit nicht in diesem Monat in den TrendPortfolio Index fließen, wird entsprechend weniger investiert."
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "spv-asset-classes" },
                [
                  _vm._l(_vm.constituent_data[_vm.deadline_id], function(
                    item,
                    index
                  ) {
                    return [
                      _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "small-12 medium-6 large-4 spv-card-widget"
                        },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                "spv-card-widget__card",
                                { marked: item.weight === 25 }
                              ]
                            },
                            [_c("h2", [_vm._v(_vm._s(item.name))])]
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.indexId === "deka"
        ? _c("div", { staticClass: "row wrapper-spacing" }, [
            _c("div", { staticClass: "medium-12 large-12 columns" }, [
              _c("h1", [
                _vm._v(
                  "Zusammensetzung der Anlageklassen " +
                    _vm._s(_vm.indexName_) +
                    " " +
                    _vm._s(_vm.deadline_.name)
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("b", [
                  _vm._v(
                    "Stand " +
                      _vm._s(
                        _vm.getAssetsMonthName(_vm.deka_assets.assets_month) +
                          " " +
                          _vm.deka_assets.assets_year
                      )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.configTextOfAsset) }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "medium-12 large-12 columns" },
              [
                _c("n-accordion-chart", {
                  attrs: { items: _vm.dekaAssetsChartData }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.indexId === "climate"
        ? _c("div", { staticClass: "row wrapper-spacing" }, [
            _c("div", { staticClass: "medium-12 large-12 columns" }, [
              _c("h1", [
                _vm._v(
                  "Zusammensetzung der Aktien des " +
                    _vm._s(_vm.indexName_) +
                    " " +
                    _vm._s(_vm.deadline_.name)
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("b", [
                  _vm._v(
                    "Stand " +
                      _vm._s(
                        _vm.getAssetsMonthName(
                          _vm.climate_assets.assets_month
                        ) +
                          " " +
                          _vm.climate_assets.assets_year
                      )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.configTextOfAsset) }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "small-12 medium-12 large-12 columns chart-spacing"
              },
              [
                _c("n-accordion-chart", {
                  attrs: { items: _vm.climateAssetsChartData }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.configText60
        ? _c("div", { staticClass: "row wrapper-spacing" }, [
            _c("div", { staticClass: "medium-12 large-12 columns" }, [
              _c("br"),
              _vm._v(" "),
              _c("h2", [_vm._v("Details zum Indexportfolio")]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.configText60) } })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.climate_assets.assets
        ? _c("div", { staticClass: "row wrapper-spacing" }, [
            _c("div", { staticClass: "small-12 medium-12 large-12 columns" }, [
              _c("div", { staticClass: "spv-table-wrapper" }, [
                _c("input", {
                  class: "climate-asset-filter",
                  attrs: {
                    type: "text",
                    placeholder: "Suche nach Name, Land oder Industrie"
                  },
                  domProps: { value: _vm.asset_filter },
                  on: {
                    input: function(e) {
                      return (_vm.asset_filter = e.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "table",
                  {
                    staticClass:
                      "spv-product-table spv-index-table spv-index-table--climate"
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.climateAssets, function(asset, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [_vm._v(_vm._s(asset.name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(asset.country))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(asset.industry))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.formatPercent(asset.weight, 2)))
                          ])
                        ])
                      })
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.climate_assets.assets.length > 10
                  ? _c("div", { staticClass: "text-center" }, [
                      !_vm.asset_filter
                        ? _c(
                            "a",
                            {
                              staticClass: "toggle-expand",
                              on: {
                                click: function($event) {
                                  _vm.show_all_rows = !_vm.show_all_rows
                                }
                              }
                            },
                            [
                              !_vm.show_all_rows
                                ? _c("i", { staticClass: "fo fo-arrow-down" })
                                : _c("i", { staticClass: "fo fo-arrow-up" })
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.factsheet_path[_vm.deadline_id] && _vm.indexId !== "trend"
        ? _c("div", { staticClass: "row wrapper-spacing" }, [
            _c("div", { staticClass: "medium-12 large-12 columns" }, [
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "button call-to-action",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.onOpenFactsheet(_vm.factsheet_path[_vm.deadline_id])
                      }
                    }
                  },
                  [_vm._v("\n          Download Factsheet\n        ")]
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Land")]),
        _vm._v(" "),
        _c("th", [_vm._v("Industrie")]),
        _vm._v(" "),
        _c("th", [_vm._v("Gewichtung")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d1ab93e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1ab93e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/index/spv_general.vue
// module id = d2+l
// module chunks = 0